<template>
  <div>
    <b-container class="custom-container mt-5 pt-5">
      <b-row>
        <b-col cols="12" class="px-3 mt-5">
          <b-breadcrumb
            :items="breadcrumbItems"
            class="pl-0 bg-transparent"
          ></b-breadcrumb>
          <b-container fluid>
            <b-row
              ><h4 class="font-weight-bold">{{ pageTitle }}</h4></b-row
            >
          </b-container>
          <b-card border-variant="light" bg-variant="light" body-class="px-0">
            <file-list
              v-if="files.length"
              ref="files"
              :files="files"
              :is-requests-files-page="true"
              @selectedFiles="filesSelected"
              @shareSingleFile="shareFiles"
            />
            <div v-else class="py-5 text-center">
              <b-img
                fluid
                src="/img/empty-req.svg"
                alt="No matching files"
                class="mb-4"
                style="max-height: 160px"
              ></b-img>
              <h5 class="font-weight-bold mb-2">
                Oops! No matching files found
              </h5>
              <p class="text-secondary mb-0">
                Looks like you don't have any{{
                  requestName ? ` ${requestName}` : ''
                }}
                files uploaded yet.
              </p>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <subscription-modal v-model="show" @close="show = false" />
    <share-file-modal
      :showShareFiles="showShareFiles"
      :selectedFiles="checkedFiles"
      :fileShares="fileShares"
      @closeShareFileModal="showShareFiles = false"
      @fileShareResponsePrompt="shareFileResponsePrompt"
      @reloadFileList="getFileList"
    />

    <b-alert
      class="custom-alert"
      :show="dismissCountDown"
      :class="{
        'bg-danger border-danger': alertType === 'danger',
      }"
      dismissible
      fade
      :variant="alertType"
      @dismiss-count-down="countDownChanged"
    >
      {{ alertMsg }}
    </b-alert>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { find } from 'lodash'
import FileList from '@/components/lists/FileList'
import SubscriptionModal from '@/components/modals/SubscriptionModal'
import ShareFileModal from '@/components/modals/ShareFileModal'

export default {
  components: {
    FileList,
    SubscriptionModal,
    ShareFileModal,
  },

  data() {
    return {
      loading: false,
      checkedFiles: [],
      show:
        this.$route.params.show === undefined ? false : this.$route.params.show,
      showShareFiles: false,
      fileShares: [],
      dismissCountDown: 0,
      alertMsg: null,
      alertType: 'primary',
    }
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    ...mapGetters('file', ['files']),
    requestName() {
      return this.$route.query.name || ''
    },
    requestTemplateId() {
      const id = parseInt(this.$route.query.template_id, 10)
      return Number.isFinite(id) && id > 0 ? id : null
    },
    pageTitle() {
      return this.requestName ? `${this.requestName} Files` : 'Files'
    },
    breadcrumbItems() {
      return [
        {
          text: 'Requests',
          to: '/requests',
        },
        { text: 'Files' },
      ]
    },
  },

  methods: {
    ...mapActions({
      getValidFiles: 'file/getValidFiles',
    }),
    async getFileList() {
      this.loading = true
      this.clearSelectedFiles()
      try {
        await this.getValidFiles({
          name: this.requestName,
          templateId: this.requestTemplateId,
        })
      } catch (e) {
        this.$bvToast.toast('Could not load files. Please try again.', {
          variant: 'danger',
          title: 'Error',
        })
      } finally {
        this.loading = false
      }
    },
    filesSelected(files) {
      this.checkedFiles = files
    },
    clearSelectedFiles() {
      this.checkedFiles = []

      // this.$refs ? this.$refs.files.clearFilesSelected() : null
    },
    async bulkDownload() {
      await this.$api
        .get('download-bulk-files', {
          responseType: 'blob',
          params: { files: this.checkedFiles },
        })
        .then((data) => {
          const name = this.user.full_name
          const filename = `${name}.zip`
          const url = URL.createObjectURL(
            new Blob([data.data], {
              type: 'application/zip',
            }),
          )
          const link = document.createElement('a')

          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
        .catch((e) => {
          setTimeout((e) => {
            this.$emit('showAlert', 'downloaded unsuccessfully.')
          }, 5000)
        })
    },
    shareFiles() {
      let fileShared = find(this.files, { id: this.checkedFiles[0] })
      this.fileShares = fileShared.file_shares
      this.showShareFiles = true
    },
    async shareFileResponsePrompt(res) {
      if (res.success) {
        await this.getFileList()

        this.alertMsg =
          'File request shared successfully to selected emails: ' +
          res.data.success.join(', ')

        this.dismissCountDown = 15

        return
      } else {
        this.alertType = 'danger'

        if (res.status === 402 || res.status === 422) {
          if (res.message) {
            this.alertMsg = res.message
          } else {
            this.alertMsg = 'File shared unsuccessful!'
          }
        } else {
          this.alertMsg =
            'Something went wrong while submitting the share file email!'
        }
      }

      this.dismissCountDown = 5
    },
    showAlert() {
      this.dismissCountDown = 5
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    clearAlert() {
      this.dismissCountDown = 0
      this.alertMsg = null
      this.alertType = 'primary'
    },
  },
  created() {
    this.getFileList()
  },
}
</script>

<style lang="scss" scoped>
.header-image {
  // top: 88px;
  // height: 280px;
  background: transparent linear-gradient(130deg, #006cff 0%, #00429d 100%) 0%
    0% no-repeat padding-box;
}

.header-text {
  // top: 136px;
  margin-top: 88px;
  font-size: 35px;
}

/deep/ nav.center-screen {
  margin-top: 0;
}

.file-menu-container {
  background: white;
  // height: 88px;
  border: 1px solid #b6c3d94d;
  border-radius: 8px;
}
</style>
